var map = {
	"./asset-hyperlink.json": 82908,
	"./blockquote.json": 16444,
	"./document.json": 51746,
	"./embedded-asset-block.json": 6712,
	"./embedded-entry-block.json": 1264,
	"./embedded-entry-inline.json": 91020,
	"./embedded-resource-block.json": 8866,
	"./embedded-resource-inline.json": 47618,
	"./entry-hyperlink.json": 60360,
	"./heading-1.json": 70371,
	"./heading-2.json": 67598,
	"./heading-3.json": 30373,
	"./heading-4.json": 89000,
	"./heading-5.json": 85255,
	"./heading-6.json": 9058,
	"./hr.json": 72809,
	"./hyperlink.json": 29929,
	"./list-item.json": 2695,
	"./ordered-list.json": 49883,
	"./paragraph.json": 35045,
	"./resource-hyperlink.json": 10248,
	"./table-cell.json": 38332,
	"./table-header-cell.json": 29522,
	"./table-row.json": 49906,
	"./table.json": 24739,
	"./text.json": 67980,
	"./unordered-list.json": 35028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41289;